// Local storage management for contact form

const STORAGE_KEY = 'contactFormData';

export const saveFormData = (name, email, phone, message) => {
  const data = { name, email, phone, message };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getFormData = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      console.error('Failed to parse form data:', e);
      return null;
    }
  }
  return null;
};

export const clearFormData = () => {
  localStorage.removeItem(STORAGE_KEY);
};
